import React, { useState } from "react";
import "./WebTrader.css";

export default function WebTrader() {
  const [serverName, setServerName] = useState("");
  const [serverSource, setServerSource] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Server Name: ${serverName}\nServer Source: ${serverSource}`);
  };

  return (
    <div className="webtrader-page">
      {/* Page Header */}
      <div className="page-header">
        <h2>Web Trader</h2>
        <div className="breadcrumb">
          <a href="/">Home</a> / <span>Platform Settings</span> / Web Trader
        </div>
      </div>

      {/* Card */}
      <div className="card">
        <h4>Update Web Trader</h4>
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>Web Trader Server Name</label>
              <input
                type="text"
                placeholder=""
                value={serverName}
                onChange={(e) => setServerName(e.target.value)}
              />
              <small>Type server name (Optional).</small>
            </div>
            <div className="form-group">
              <label>Web Trader Server Source</label>
              <input
                type="text"
                placeholder=""
                value={serverSource}
                onChange={(e) => setServerSource(e.target.value)}
              />
              <small>Type Web Trader URL i.e. http://172.0.0.1:4443</small>
            </div>
          </div>
          <button type="submit" className="btn-update">
            Update
          </button>
        </form>
      </div>

      {/* Footer */}
      <footer className="page-footer">
        <p>
          Copyright © 2025 <span>Ample Markets</span>. All rights reserved.
        </p>
        <p className="version">Version 2.0</p>
      </footer>
    </div>
  );
}
